import reducer from './js/app/reducer';
import './SchemeColor';
import './resources/custom-script';

window.kinosite = {
	reducer,
};
